import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  deleteANewsCat,
  getCategories,
  resetState,
} from "../features/CountryCatSclice";
import CustomModal from "../../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Country Category List",
    dataIndex: "category_name"
  },
  {
    title: "Country Name",
    dataIndex: "Country_name"
  },

  {
    title: "Action",
    dataIndex: "action",
  },
];

const Newscatlist = () => {
  const [open, setOpen] = useState(false);
  const [NewsCatId, setNewsCatId] = useState("");
  const [NewsCatIdd, setNewsCatIdd] = useState("");
  const showModal = (e1,e2) => {
    setOpen(true);
    setNewsCatId(e1);
    setNewsCatIdd(e2);
  };

  const hideModal = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetState());
    dispatch(getCategories());
  }, []);
  const bCatState = useSelector((state) => state.countryCat.bCategories);
  console.log(bCatState);
  const data1 = [];
  for (let i = 0; i < bCatState.length; i++) {
    data1.push({
      key: i + 1, 
      category_name: bCatState[i].data.categoryName,
      Country_name: bCatState[i].countryName,
      action: (
        <>
          <Link
            to={`/admin/Add-Country-Category/${bCatState[i].countryId}/${bCatState[i].cityId}`}
            className=" fs-3 text-danger"
          >
            <BiEdit />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(bCatState[i].countryId, bCatState[i].cityId)}
            >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }
  const deleteNewsCategory = (e1,e2) => {
    dispatch(deleteANewsCat({  id: e1, secondId: e2}));
    setOpen(false);
    setTimeout(() => {
      dispatch(getCategories());
    }, 100);
  };
  return (
    <div>
      <h3 className="mb-4 title">Country Categories List</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteNewsCategory(NewsCatId,NewsCatIdd);
        }}
        title="Are you sure you want to delete this  Country?"
      />
    </div>
  );
};

export default Newscatlist;
